/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=72c981f3"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=72c981f3&lang=css"

import exportComponent from "F:\\System\\sengi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__